import {connect} from "react-redux"
import {State} from "../../../../ducks"
import {getPlpUrl} from "../../../../ducks/search"

export const mapStateToProps = (state: State) => {
    const {q, numFound, suggestions, isLoading} = state.autocomplete
    const {siteUrl} = state.request
    const {
        text: {autoComplete},
    } = state
    return {
        text: autoComplete,
        siteUrl,
        term: q,
        numFound,
        suggestions,
        isLoading,
    }
}

export const mapDispatchToProps = () => ({
    getConnectedPlpUrl: (suggestion: string, siteUrl: string) => getPlpUrl(siteUrl)(suggestion),
})

export default connect(mapStateToProps, mapDispatchToProps)
